const {
  default: Cookies
} = require('universal-cookie');

const {
  addDays
} = require('date-fns');

function saveSessionCookie(cookie) {
  const cookies = new Cookies();
  cookies.set('session', cookie, _getCookieOptions());
}

function getSessionCookie() {
  const cookies = new Cookies();
  return cookies.get("session");
}

function deleteSessionCookie() {
  const cookies = new Cookies();
  return cookies.remove("session", _getCookieOptions());
}

function _getCookieDomain() {
  const domainSegments = document.domain.split(".");

  if (domainSegments.length > 1) {
    return domainSegments.slice(domainSegments.length - 2).join(".");
  }

  return document.domain;
}

function _getCookieOptions() {
  return {
    path: "/",
    domain: _getCookieDomain(),
    expires: addDays(new Date(), 7)
  };
}

module.exports = {
  saveSessionCookie,
  getSessionCookie,
  deleteSessionCookie
};